const DOMAIN_CONFIG = {
  'acs.pdic.support': {
    tenant_code: 'PDIC',
    app_name: 'PDIC',
    logo_url: 'https://desk.pdic.support/uploads/photos/3cbc7462-d263-44d2-929d-875b0a350783.jpeg',
    primary_color: '#1B6B3A',
    placeholder: 'PDIC',
    type: 'admin',
    tenant_type: 'distributor'
  },
  'myconnection.pdic.support': {
    tenant_code: 'PDIC',
    app_name: 'PDIC My Connection',
    logo_url: 'https://desk.pdic.support/uploads/photos/3cbc7462-d263-44d2-929d-875b0a350783.jpeg',
    primary_color: '#1B6B3A',
    placeholder: 'PDIC',
    type: 'customer'
  },
  'myconnection.fibralink.co.in': {
    tenant_code: '',
    app_name: 'My Connection',
    logo_url: '',
    primary_color: '#1B6B3A',
    placeholder: 'Enter tenant code',
    type: 'customer'
  },
  'acs.fibralink.co.in': {
    tenant_code: '',
    app_name: 'FibraACS',
    logo_url: '',
    primary_color: '#1B6B3A',
    placeholder: 'e.g. FIBRA',
    type: 'admin'
  },
  'default': {
    tenant_code: '',
    app_name: 'FibraACS',
    logo_url: '',
    primary_color: '#1B6B3A',
    placeholder: 'Enter tenant code',
    type: 'admin'
  }
};

export const getDomainConfig = () => {
  const hostname = window.location.hostname;
  return DOMAIN_CONFIG[hostname] || DOMAIN_CONFIG['default'];
};
